module.exports = __webpack_public_path__ + "img/18.031c73a5.png";